import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";

class AssetBalanceAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AssetBalance";

  /** author: ĐVThi
   *  Create date: 21/02/2021
   *  Lấy danh sách vị trí tài sản dùng để cấp phát/thu hồi
   */
  getAssetBalanceByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /** author: ntnghia
   *  Create date: 17/03/2021
   *  Lấy danh sách tài sản trong bảng AssetBalance theo mã tài sản dùng để cấp phát/thu hồi
   */
  getAssetBalanceFullFieldByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * nnphong
   * created date" 20/3/2021
   * lấy tài sản có số lượng tồn > 0 theo mã tài sản.
   */
  getAssetBalanceFullFieldByAssetStatus(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-assetstatus"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * nnphong
   * created date" 20/3/2021
   * lấy tài sản có số lượng tồn > 0 theo mã tài sản. (paging)
   */
  getAssetBalanceFullFieldByAssetStatusPaging(parameter) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-assetstatus-paging"].join("/"),
      data: parameter,
    };
    return httpClient.postAsync(request);
  }
  /**
   * nnphong
   * created date" 25/3/2021
   * lấy tài sản có số lượng tồn > 0 theo mã tài sản. (paging) chỉ lấy mã code và name group by.
   */
  getAssetBalanceNotFullFieldByAssetStatusPaging(parameter) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-notfull-assetstatus-paging"].join("/"),
      data: parameter,
    };
    return httpClient.postAsync(request);
  }

  /** author: ntnghia
   *  Create date: 22/03/2021
   *  Lấy danh sách tài sản trong bảng AssetBalance theo id nhân viên dùng để cấp phát/thu hồi
   */
  getAssetBalanceFullFieldByEmployeeID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-employeeid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /** author: ntnghia
   *  Create date: 22/03/2021
   *  Lấy danh sách tài sản trong bảng AssetBalance theo id phòng ban dùng để cấp phát/thu hồi
   */
  getAssetBalanceFullFieldByOrganizationID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-organizationunitid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /** author: nmsinh
   *  Create date: 19/03/2021
   *  Lấy số lượng để kiểm tra tính hợp lệ theo nghiệp vụ chức năng
   */
  getAssetBalanceTotalByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-total-by-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /*
   * lấy toàn bộ dữ liệu bảng asset balance theo assetid
   * pvduy 24/03/2021
   */
  getAllAssetBalanceByAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "all-asset-balance-by-assetid"].join("/"),
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /*
   * lấy dữ liệu bảng asset balance theo phòng ban hoặc nhân viên
   * ntnghia 30/03/2021
   */
  getAssetBalanceFullFieldByObjectPaging(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-object-paging"].join("/"),
      data: payload,
    };

    //xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(payload);

    return httpClient.postAsync(request);
  }

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/list";

    if (payload.type == "assetUnuseHaveRemainQuantitySearch") {
      url = this.getAPIUrl() + "/asset-balance-full-assetstatus-paging";
    }

    if (payload.type == "SearchAssetForMultiAllocation") {
      url = this.getAPIUrl() + "/quick-asset-balance-multiallocation-paging";
    }

    if (payload.type == "assetHaveRemainQuantitySearch") {
      url = this.getAPIUrl() + "/asset-balance-for-asset-paging";
    }

    if (payload.type == "assetByObjectSearch") {
      url = this.getAPIUrl() + "/asset-balance-full-object-paging";
    }

    if (payload.type == "assetQuickSearch") {
      url = this.getAPIUrl() + "/asset-quick-search";
    }

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * author: ntnghia
   * Create date: 17/03/2021
   * Lấy danh sách tài sản trong bảng AssetBalance theo mã tài sản dùng để cấp phát/thu hồi
   */
  getAssetBalanceFullFieldByAssetIDForQuantity(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-assetid-for-quantity"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  getAssetBalanceTotalByAssetIDForQuantity(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-total-by-assetid-for-quantity"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * @author vvkiet - 16.04.2021
   * Thực hiện lấy danh sách tài sản ở màn hình thực hiện đề nghị thanh lý hàng loạt
   */
  getAssetBalanceForMultiRequestLiquitedAssetPaging(parameter) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-for-asset-paging"].join("/"),
      data: parameter,
    };
    return httpClient.postAsync(request);
  }

  /**
   * @author vvkiet - 17.04.2021
   * Thực hiện kiểm tra tồn của 1 danh sách tài sản
   * @param {*} payload Tham số
   * @returns Danh sách tồn của tài sản
   */
  getAssetBalanceTotalByListAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-total-by-list-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * @author vvkiet - 17.04.2021
   * Thực hiện lấy danh sách tài sản còn tồn
   * @param {*} payload Tham số
   * @returns Danh sách tồn của tài sản
   */
  getAssetBalanceFullFieldByListAssetID(payload) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-full-list-assetid"].join("/"),
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * @author tlminh - 16.04.2021
   * Thực hiện lấy danh sách tài sản ở màn hình thực hiện đánh dấu mất hàng loạt
   */
  getAssetBalanceForDisposalAssetPaging(parameter) {
    let request = {
      url: [this.getAPIUrl(), "asset-balance-for-multi-disposal-asset-paging"].join("/"),
      data: parameter,
    };
    return httpClient.postAsync(request);
  }
}

export default new AssetBalanceAPI();
